import _ from 'lodash';
import { defaultPension } from '@/app/utils/toolkit/defaults/defaultPensionKitEstablishment';
import AccountsHeader from './accounts-header/accounts-header.vue';
import AccumulationAccount from './accumulation-account/accumulation-account.vue';
import PensionAccount from './pension-account/pension-account.vue';
import AccumActModal from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/accum-act-modal/accum-act-modal.vue';

export default {
  name: 'pension-accounts',
  components: {
    AccountsHeader,
    AccumulationAccount,
    PensionAccount,
    AccumActModal,
  },
  data() {
    return {
      showAccumModal: false,
    };
  },
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    pensionSetup() {
      return this.getItem.setup;
    },
    pensions() {
      return this.getItem.pensions;
    },
    pensionsNeedReview() {
      return this.pensions.filter(pension => pension.status !== 'IN_PROGRESS').length > 0;
    },
    accumulationAccount() {
      return this.getItem.accumulation;
    },
    activePension() {
      return this.getItem.activePension;
    },
    accumNotReq() {
      const keys = ['PART_1', 'PART_2_MINI'];
      return keys.some(key => this.getItem.setup.part === key);
    },
    pensionNotReq() {
      return this.accumulationAccount.status === 'STARTED' && this.pensions.length > 0 && this.pensions.some(pension => pension.status === 'NEEDS_REVIEW');
    },
  },
  methods: {
    async requiresPension() {
      // Init initial pension
      if (this.pensionSetup.part !== 'PART_2_FULL' && this.pensions && this.pensions.length === 0) {
        await this.initPension();
      }
    },
    async initPension() {
      const currentPensions = [...this.pensions];
      const newPension = { ...defaultPension };
      currentPensions.push(newPension);
      await this.$store.dispatch('toolkit/updateItemKey', { data: { pensions: currentPensions } });
      await this.$store.dispatch('toolkit/saveItem');
    },
    async loadPension(idx) {
      await this.$store.dispatch('toolkit/updateItemKey', { data: { activePension: idx } });
    },
    async changeActivePensionStatus(status) {
      const pensions = _.cloneDeep(this.pensions);
      pensions[this.activePension].status = status;
      await this.$store.dispatch('toolkit/updateItemKey', { data: { pensions } });
    },
    async handlePensionAction(action, idx) {
      switch (action) {
        case 'start':
          await this.loadPension(idx);
          await this.changeActivePensionStatus('IN_PROGRESS');
          this.$emit('start-pension');
          break;
        case 'edit':
          await this.loadPension(idx);
          this.$emit('edit-pension');
          break;
        default:
          console.warn('PENSION_ACCOUNTS::Unknown pension action', action);
      }
    },
    async handleAccumAction(action) {
      switch (action) {
        case 'start':
        case 'edit':
          this.showAccumModal = true;
          break;
        default:
          console.warn('PENSION_ACCOUNTS::Unknown accum action', action);
      }
    },
    handleClose(action) {
      this.showAccumModal = false;
      if (action === 'init-pension') {
        this.initPension();
      } else if (action === 'review-pension') {
        const updatedPensions = this.pensions.map(pension => ({
          ...pension,
          status: pension.status !== 'STARTED' ? 'NEEDS_REVIEW' : pension.status,
        }));

        this.$store.dispatch('toolkit/updateItemKey', { data: { pensions: updatedPensions } });
      }
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  async activated() {
    await this.requiresPension();
  },
  validations: {},
};
